import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    // Store error details in state for display
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Optionally log to error reporting service
    // logErrorToService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Render custom fallback UI
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          backgroundColor: '#0B1220',
          color: '#fff'
        }}>
          <div style={{
            maxWidth: '800px',
            width: '100%',
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 16,
            padding: 24
          }}>
            <h2 style={{
              color: '#fca5a5',
              marginBottom: 16,
              fontSize: 24,
              fontWeight: 600
            }}>
              ⚠️ Something went wrong
            </h2>
            
            <p style={{
              color: '#cbd5e1',
              marginBottom: 24,
              fontSize: 14,
              lineHeight: 1.6
            }}>
              An unexpected error occurred. Please check the details below or refresh the page.
            </p>

            {this.state.error && (
              <div style={{
                background: 'rgba(239,68,68,0.1)',
                border: '1px solid rgba(239,68,68,0.3)',
                borderRadius: 8,
                padding: 16,
                marginBottom: 16
              }}>
                <h3 style={{
                  color: '#fca5a5',
                  fontSize: 16,
                  fontWeight: 600,
                  marginBottom: 8
                }}>
                  Error Message:
                </h3>
                <pre style={{
                  color: '#fee2e2',
                  fontSize: 12,
                  fontFamily: 'monospace',
                  overflow: 'auto',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  margin: 0,
                  padding: 12,
                  background: 'rgba(0,0,0,0.3)',
                  borderRadius: 4
                }}>
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack && (
                    <>
                      {'\n\n'}
                      Component Stack:
                      {this.state.errorInfo.componentStack}
                    </>
                  )}
                </pre>
              </div>
            )}

            {this.state.errorInfo && (
              <details style={{
                marginTop: 16,
                color: '#94a3b8',
                fontSize: 13
              }}>
                <summary style={{
                  cursor: 'pointer',
                  marginBottom: 8,
                  color: '#60a5fa'
                }}>
                  Show full error details
                </summary>
                <pre style={{
                  color: '#cbd5e1',
                  fontSize: 11,
                  fontFamily: 'monospace',
                  overflow: 'auto',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  margin: 0,
                  padding: 12,
                  background: 'rgba(0,0,0,0.3)',
                  borderRadius: 4,
                  maxHeight: '400px',
                  overflowY: 'auto'
                }}>
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}

            <div style={{
              marginTop: 24,
              display: 'flex',
              gap: 12
            }}>
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: '12px 24px',
                  borderRadius: 8,
                  background: '#3b82f6',
                  color: '#fff',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: 14
                }}
              >
                Reload Page
              </button>
              <button
                onClick={() => {
                  localStorage.removeItem('authToken');
                  localStorage.removeItem('user');
                  window.location.href = '/login';
                }}
                style={{
                  padding: '12px 24px',
                  borderRadius: 8,
                  background: 'rgba(255,255,255,0.1)',
                  color: '#fff',
                  border: '1px solid rgba(255,255,255,0.2)',
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: 14
                }}
              >
                Go to Login
              </button>
            </div>

            <div style={{
              marginTop: 24,
              padding: 12,
              background: 'rgba(59,130,246,0.1)',
              border: '1px solid rgba(59,130,246,0.3)',
              borderRadius: 8,
              fontSize: 12,
              color: '#93c5fd'
            }}>
              <strong>Tip:</strong> Open browser DevTools (F12) and check the Console tab for more detailed error information.
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

